export const METRIC_BADGE_TONES = {
  General: {
    code: "border-purple-300 text-purple-500 dark:border-purple-700 dark:text-purple-300",
    category:
      "border-purple-300 bg-purple-50 text-purple-500 dark:border-purple-700 dark:bg-purple-500/10 dark:text-purple-300",
  },
  Environmental: {
    code: "border-green-300 text-green-500 dark:border-green-700 dark:text-green-400",
    category:
      "border-green-300 bg-green-50 text-green-500 dark:border-green-700 dark:bg-green-500/10 dark:text-green-400",
  },
  Social: {
    code: "border-indigo-300 text-blue-500 dark:border-blue-700 dark:text-blue-300",
    category:
      "border-indigo-300 bg-blue-50 text-blue-500 dark:border-blue-700 dark:bg-blue-500/10 dark:text-blue-300",
  },
  Governance: {
    code: "border-amber-300 text-amber-600 dark:border-amber-700 dark:text-amber-500",
    category:
      "border-amber-300 bg-amber-50 text-amber-600 dark:border-amber-700 dark:bg-amber-500/10 dark:text-amber-500",
  },
};
